import { createFileRoute, redirect } from "@tanstack/react-router";

import { meQuery, systemInfoQuery } from "@/api/queries";
import { AppShell } from "@/features/shell/AppShell";

/** Layout for every signed-in page. Cloud: enforces setup, sign-in and forced password change. */
export const Route = createFileRoute("/_app")({
  beforeLoad: async ({ context, location }) => {
    const info = await context.queryClient.ensureQueryData(systemInfoQuery);
    if (info.edition === "local") return { info, me: null };

    if (info.setup_required) throw redirect({ to: "/setup" });
    const me = await context.queryClient.fetchQuery(meQuery);
    if (!me) throw redirect({ to: "/login", search: { redirect: location.href } });
    if (me.must_change_password && location.pathname !== "/account/password") {
      throw redirect({ to: "/account/password" });
    }
    return { info, me };
  },
  component: AppShell,
});
